import { APP_INITIALIZER, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ContentControlStudioComponent } from "./content-control-studio.component";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { ContentControlStudioRoutes } from "./content-control-studio.routes";
import { ContentControlStudioRootComponent } from "../content-control-studio-root/content-control-studio-root.component";
import { IContentControlManager } from 'app/js/src/domain/content-control/manager';
import { ContentControlManagerImpl } from 'app/js/src/infrastructure/content-control/content-control-manager.service';
import { IContentControlRepository } from 'app/js/src/domain/content-control/repository';
import { ContentControlRepositoryImpl } from "app/js/src/infrastructure/content-control/content-control-repository.service";
import { HttpService } from "../../../../infrastructure/http/http";
import { Auth } from "../../../../infrastructure/auth";
import { UI } from "app/js/src/services/ui.service";
import { ContentControlStudioVODHeaderComponent } from "./content-control-studio-header/VOD/content-control-studio-vod-header.component";

import { ContentControlStudioEventsComponent } from "./content-control-studio-events/content-control-studio-events.component";
import { ContentControlStudioEventComponent } from "./content-control-studio-events/content-control-studio-event/content-control-studio-event.component";
import { ContentControlStudioActionButtonComponent } from "./content-control-studio-actions/content-control-studio-action-button/content-control-studio-action-button.component";
import { ContentControlStudioActionsComponent } from "./content-control-studio-actions/content-control-studio-actions.component";
import { EvrideoCommonModule } from "../../../common/evrideo-common.module";
import { ContentControlStudioVODTimelineComponent } from "./content-control-studio-timeline/content-control-studio-vod-timeline.component";
import { ContentControlStudioTimelineSegmentComponent } from "./content-control-studio-timeline/content-control-studio-timeline-segment/content-control-studio-timeline-segment.component";
import { ContentControlStudioDropdownComponent } from "./content-control-studio-dropdown/content-control-studio-dropdown.component";
import { ContentControlCanvasService } from "app/js/src/infrastructure/content-control/content-control-canvas.service";
import { ContentControlStudioTimelineTrackSegmentComponent } from "./content-control-studio-timeline/content-control-studio-timeline-track-segment/content-control-studio-timeline-track-segment.component";
import { BackofficeUserBrandingSettings } from "app/js/src/domain/user-branding";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { ContentControlStudioTimelineInclusiveSegmentComponent } from "./content-control-studio-timeline/content-control-studio-timeline-inclusive-segment/content-control-studio-timeline-inclusive-segment.component";
import { ContentControlStudioSubtitleEditorComponent } from "./content-control-studio-subtitle-editor/content-control-studio-subtitle-editor.component";
import { ContentControlStudioSettingsComponent } from "./content-control-studio-settings/content-control-studio-settings.component";
import { ContentManagerGuard } from "app/js/src/guards/permission.guard";
import { TenantSettingsRepository } from "app/js/src/domain/tenant-settings-repository";
import { CachedTenantSettingsRepositoryImpl } from "app/js/src/infrastructure/repositories/tenant/tenantSettings";
import { MediaTranscoderRepository } from "app/js/src/infrastructure/repositories/media-transcoder/media-transcoder-repository";
import { IMediaTranscoderRepository } from "app/js/src/domain/media-transcoder/media-transcoder.repository";
import { MediaRepository } from "app/js/src/domain/media-repository";
import { MediaRepositoryImpl } from "app/js/src/infrastructure/repositories/media/media";
import { MediaMapper } from "app/js/src/infrastructure/repositories/media/media.mapper";
import { TenantRepository } from "app/js/src/domain/tenant-repository";
import { TenantRepositoryImpl } from "app/js/src/infrastructure/repositories/tenant/tenant";
import { ToastrModule } from "ngx-toastr";
import {
  ObserveVisibilityDirective
} from "./content-control-studio-events/observe-visibility.directive";
import { ContentControlStudioLiveHeaderComponent } from "./content-control-studio-header/Live/content-control-studio-live-header.component";
import { ContentControlStudioLiveTimelineComponentV2 } from "./content-control-studio-timeline/content-control-studio-live-timeline-v2.component";
import { ContentControlStudioHlsDebugPanelComponent } from "./content-control-studio-hls-debug-panel/content-control-studio-hls-debug-panel.component";
import { ContentControlStudioVodDebugPanelComponent } from "./content-control-studio-vod-debug-panel/content-control-studio-vod-debug-panel.component";
import { MarkInIconComponent } from './shared-objects/mark-in-icon/mark-in-icon.component';
import { MarkOutIconComponent } from './shared-objects/mark-out-icon/mark-out-icon.component';
import { SkipBackwardIconComponent } from './shared-objects/skip-backward-icon/skip-backward-icon.component';
import { StepBackwardIconComponent } from './shared-objects/step-backward-icon/step-backward-icon.component';
import { PauseIconComponent } from './shared-objects/pause-icon/pause-icon.component';
import { PlayIconComponent } from './shared-objects/play-icon/play-icon.component';
import { StepForwardIconComponent } from './shared-objects/step-forward-icon/step-forward-icon.component';
import { SkipForwardIconComponent } from './shared-objects/skip-forward-icon/skip-forward-icon.component';
import { ZoomOutIconComponent } from './shared-objects/zoom-out-icon/zoom-out-icon.component';
import { ZoomInIconComponent } from './shared-objects/zoom-in-icon/zoom-in-icon.component';
export function appInitFactory() {
  return async () => {
    const savedUserBrandingSettings = localStorage.getItem(
      "userBrandingSettings_backoffice",
    );
    if (savedUserBrandingSettings) {
      const userBrandingSettings = BackofficeUserBrandingSettings.FromRawObject(
        JSON.parse(savedUserBrandingSettings),
      );
      document.title = "Evrideo | Content Control Studio";
      document
        .getElementById("linkFavicon")
        .setAttribute("href", userBrandingSettings.faviconUrl);
      document
        .getElementById("imgBrowserTooSmallImage")
        .setAttribute("src", userBrandingSettings.browserTooSmallImageUrl);
      Promise.resolve();
    }
  };
}
@NgModule({
  declarations: [
    ContentControlStudioComponent,
    ContentControlStudioRootComponent,
    ContentControlStudioVODHeaderComponent,
    ContentControlStudioLiveHeaderComponent,
    ContentControlStudioEventsComponent,
    ContentControlStudioEventComponent,
    ContentControlStudioActionsComponent,
    ContentControlStudioActionButtonComponent,
    ContentControlStudioVODTimelineComponent,
    ContentControlStudioLiveTimelineComponentV2,
    ContentControlStudioTimelineSegmentComponent,
    ContentControlStudioDropdownComponent,
    ContentControlStudioTimelineTrackSegmentComponent,
    ContentControlStudioTimelineInclusiveSegmentComponent,
    ContentControlStudioSubtitleEditorComponent,
    ContentControlStudioSettingsComponent,
    ObserveVisibilityDirective,
    ContentControlStudioHlsDebugPanelComponent,
    ContentControlStudioVodDebugPanelComponent,
    MarkInIconComponent,
    MarkOutIconComponent,
    SkipBackwardIconComponent,
    StepBackwardIconComponent,
    PauseIconComponent,
    PlayIconComponent,
    StepForwardIconComponent,
    SkipForwardIconComponent,
    ZoomOutIconComponent,
    ZoomInIconComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    BrowserModule,
    RouterModule.forRoot(ContentControlStudioRoutes, {
      onSameUrlNavigation: "reload",
    }),
    EvrideoCommonModule,
    ScrollingModule,

    MatPaginatorModule,
    MatMenuModule,
    MatButtonModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 2000,
    }),
  ],
  providers: [
    ContentManagerGuard,
    HttpService,
    UI,
    MediaMapper,
    Auth,
    {
      provide: TenantSettingsRepository,
      useClass: CachedTenantSettingsRepositoryImpl,
    },
    ContentControlCanvasService,
    {
      provide: IContentControlManager,
      useClass: ContentControlManagerImpl,
    },
    {
      provide: IContentControlRepository,
      useClass: ContentControlRepositoryImpl,
    },
    {
      provide: MediaRepository,
      useClass: MediaRepositoryImpl,
    },
    {
      provide: IMediaTranscoderRepository,
      useClass: MediaTranscoderRepository,
    },
    {
      provide: TenantRepository,
      useClass: TenantRepositoryImpl,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitFactory,
      multi: true,
    },
  ],
  bootstrap: [ContentControlStudioRootComponent],
  exports: [ContentControlStudioComponent, RouterModule],
})
export class ContentControlStudioModule {}
